import React, { Fragment } from 'react';
import { capitalize } from '@mui/material';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOn';
import ExpandIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import Select from 'react-select';
import ColorPicker from '../../../Components/ColorPicker';
import { DeleteIcon } from '../../../svg/UtilsIcons';
import CreateDatastream from './CreateDatastream';
import ChartSamplingSettings from './ChartSamplingSettings';
import { getChartAggregationOptions, normalizeChartAggregation } from '../../../utils/chartAggregation';

const ChartWidgetSettings = ({
	edit,
	setEdit,
	t,
	chartTypes,
	aggregations,
	devices,
	validDatastreams,
	deviceSelectOptions,
	setAddDatastream,
	isHiddenWidgetEditorPropKey,
	themeColorKey,
	themeColorValue,
}) => (
	<Fragment>
		<ChartSamplingSettings edit={edit} setEdit={setEdit} t={t} />
		{Object.keys(edit.props).filter(k => !['xData', 'showTitle', 'labelFontSize', 'valueFontSize', 'contentAlignment', 'samplingMode', 'pointsPerHour', 'pointsPerHourByRange'].includes(k) && !isHiddenWidgetEditorPropKey(k)).map((key, idx) => (
		<div className='form-item' key={idx}>
			<label className='form-lbl' style={{ color: 'var(--header-color)' }}>{t.settingsLabels?.[key] || key}</label>
			{key === 'chart_type' ?
				<Select
					classNamePrefix="react-select"
					options={chartTypes.map(o => ({ label: o.label, value: o.value }))}
					value={chartTypes.map(o => ({ label: o.label, value: o.value })).find(o => o.value === edit.props[key])}
					onChange={selectedOption => setEdit({
						...edit,
						props: {
							...edit.props,
							[key]: selectedOption ? selectedOption.value : ''
						}
					})}
				/>
				: key === 'curves' ?
					<Fragment>
						<button className='details-add-btn' style={{ width: '120px' }}
							onClick={() => setEdit({
								...edit,
								props: {
									...edit.props,
									curves: [
										...(edit.props.curves || []),
										{
											yData: [],
											customize: false,
											min: 0,
											max: 0,
											yLabel: "Label",
											pin: "Pin",
											aggregation: "mean",
											bgColor: "#eb1518",
											hbgColor: "#fc2629",
											bdColor: "#030ae5"
										}
									]
								},
								showCurves: [...(edit.showCurves || []), false]
							})}>
							<span>+</span>
							<span>{t.addCurve}</span>
						</button>
						{(edit.props.curves || []).map((curve, index) => (
							<div className='details-curves-item' key={index}>
								<div className='details-hierarchy-tree' style={{
									width: '100%', flexDirection: 'row'
								}}>
									<button className='details-actions-btn'
										style={{
											margin: 0, borderRadius: 8,
										}} onClick={() => setEdit({
											...edit, showCurves: (edit.showCurves || []).map(
												(sh, i) => i === index ? !sh : sh)
										})}>
										<ExpandIcon style={{
											transform: (edit.showCurves || [])[index] ? 'rotate(180deg)' : 'rotate(0)',
											transition: 'transform .2s linear'
										}} />
									</button>
									<input type='text' className='add-column' placeholder={t.label}
										style={{
											width: 'calc(100% - 64px)',
											padding: '4px 10px',
											marginInlineEnd: 4,
											color: 'var(--cell--color)',
											caretColor: 'var(--cell--color)'
										}}
										value={curve.yLabel !== null ? curve.yLabel : ''}
										onChange={(e) =>
											setEdit(prev => ({
												...prev,
												props: {
													...prev.props,
													curves: (prev.props.curves || []).map((c, id) =>
														id === index ? { ...c, yLabel: e.target.value } : { ...c }
													)
												}
											}))
										}
									/>
									<button className='details-delete-btn'
										style={{ position: 'static' }} onClick={() => setEdit({
											...edit,
											showCurves: (edit.showCurves || []).filter((_sh, i) => i !== index),
											props: {
												...edit.props,
												curves: (edit.props.curves || []).filter((_c, i) => i !== index)
											}
										})}>
										<DeleteIcon color={'var(--part-background)'} />
									</button>
								</div>
								{edit.showCurves[index] && Object.keys(curve).filter(
									k => k !== 'yLabel' && k !== 'yData' && !k.endsWith('Light')).map((k, i) => (

										<div className='form-item' key={i} style={
											k.toLowerCase().includes('color') && k !== 'changeColorBasedOnValue' && k !== 'colors' ?
												{ display: 'inline-block', width: '33%' }
												: k === 'aggregation' || k === 'pin' ?
													{ display: 'inline-block', width: '75%', marginInlineEnd: '1%' }
													: { display: 'block', width: '100%' }}>
											{!(!curve.customize && (k === 'min' || k === 'max')) && <label className='form-lbl' style={{ color: 'var(--header-color)' }}>
												{(devices?.length > 0 && k === 'pin') ? '' : (t.settingsLabels?.[k] || k)}</label>}
											{k.toLowerCase().includes('color') && k !== 'changeColorBasedOnValue' && k !== 'colors' ?
												<ColorPicker
													id={`curve-${k}-${index}`}
													color={themeColorValue(curve, k)}
													setColor={(color) => setEdit(prev => ({
														...prev,
														props: {
															...prev.props,
															curves: (prev.props.curves || []).map((c, id) => id === index ? {
																...c, [themeColorKey(k)]: color
															} : c)
														}
													}))}
												/>
												: k === 'pin' ?
													(validDatastreams?.length > 0
														? (
															<>
																<Select
																	classNamePrefix="react-select"
																	options={validDatastreams.map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin }))}
																	value={validDatastreams.map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin })).find(ds => ds.value === curve[k])}
																	onChange={selectedOption => {
																		const datastream = validDatastreams.find(ds => ds.pin === (selectedOption ? selectedOption.value : ''));
																		setEdit(prev => ({
																			...prev,
																			props: {
																				...prev.props,
																				curves: (prev.props.curves || []).map((c, id) => id === index ? {
																					...c, [k]: datastream?.pin || '', yLabel: datastream?.name || ''
																				} : c)
																			}
																		}));
																	}}
																	isClearable={true}
																/>
																<CreateDatastream
																	onSelect={(cat) => setAddDatastream({ edit: true, pinCategory: cat })}
																/>
															</>
														)
														: (devices?.length > 0 ?
															<div>
																<div className='form-item'>
																	<label className='form-lbl'>{t.deviceLabel}</label>
																	<Select
																		classNamePrefix="react-select"
																		options={deviceSelectOptions}
																		value={deviceSelectOptions.find(device => device.value === curve.deviceId)}
																		onChange={selectedOption => {
																			setEdit({
																				...edit,
																				props: {
																					...edit.props,
																					curves: (edit.props.curves || []).map((c, id) => id === index ? {
																						...c, deviceId: selectedOption ? selectedOption.value : 0
																					} : c)
																				}
																			});
																		}
																		}
																		isClearable={true}
																	/>
																</div>
																{curve.deviceId ?
																	<div>
																		<label className='form-lbl' style={{ color: 'var(--header-color)' }}>
																			{t.pinLabel}</label>
																		<Select
																			classNamePrefix="react-select"
																			options={(((devices || []).find(device => device.id === curve.deviceId))?.template?.datastreams || []).filter(ds => ds).map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin }))}
																			value={(((devices || []).find(device => device.id === curve.deviceId))?.template?.datastreams || []).filter(ds => ds).map(ds => ({ label: `${ds.name} [${ds.pin}]`, value: ds.pin })).find(ds => ds.value === curve[k])}
																			onChange={selectedOption => {
																				const datastream = (((devices || []).find(device => device.id === curve.deviceId))?.template?.datastreams || []).find(
																					ds => ds && ds.pin === (selectedOption ? selectedOption.value : ''));
																				setEdit(prev => ({
																					...prev,
																					props: {
																						...prev.props,
																						curves: (prev.props.curves || []).map((c, id) => id === index ? {
																							...c, [k]: datastream?.pin || '', yLabel: datastream?.name || ''
																						} : c)
																					}
																				}));
																			}}
																			isClearable={true}
																		/>

																	</div>
																	: null}
															</div> : (!((devices || []).length > 0) ? <CreateDatastream onSelect={(cat) => setAddDatastream({
																edit: true,
																pinCategory: cat
															})} /> : null)))
													: k === 'aggregation' ?
														<Select
															classNamePrefix="react-select"
															options={getChartAggregationOptions(aggregations)}
															value={getChartAggregationOptions(aggregations).find(o => o.value === normalizeChartAggregation(curve[k]))}
															onChange={selectedOption => {
																setEdit({
																	...edit,
																	props: {
																		...edit.props,
																		curves: (edit.props.curves || []).map((c, id) => id === index ? {
																			...c, [k]: selectedOption ? normalizeChartAggregation(selectedOption.value) : 'mean'
																		} : c)
																	}
																})
															}}
															isClearable={true}
														/>
														: k === 'customize'
															? (curve[k] ?
																<ToggleOn style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer', display: 'block' }}
																	onClick={() => setEdit({
																		...edit, props: {
																			...edit.props, curves: (edit.props.curves || []).map((c, id) => id === index ? {
																				...c, [k]: false
																			} : c)
																		}
																	})} /> :
																<ToggleOff style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer', display: 'block' }}
																	onClick={() => setEdit({
																		...edit, props: {
																			...edit.props, curves: (edit.props.curves || []).map((c, id) => id === index ? {
																				...c, [k]: true
																			} : c)
																		}
																	})} />)
															: (k === 'min' || k === 'max')
																? curve.customize
																	? <input type='text' className='add-column' placeholder={capitalize(k)}
																		style={{ padding: '4px 10px', color: 'var(--cell--color)', caretColor: 'var(--cell--color)' }}
																		value={curve[k] !== null ? curve[k] : ''}
																		onChange={(e) => setEdit({
																			...edit,
																			props: {
																				...edit.props,
																				curves: (edit.props.curves || []).map((c, id) => id === index ? {
																					...c, [k]: e.target.value
																				} : c)
																			}
																		})} />
																	: null
																: null}
										</div>
									))}

							</div>))}
					</Fragment>
					: typeof edit.props[key] === 'boolean' ?
						(edit.props[key] ?
							<ToggleOn style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
								onClick={() => setEdit(prev => ({
									...prev,
									props: { ...prev.props, [key]: false }
								}))} /> :
							<ToggleOff style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
								onClick={() => setEdit(prev => ({
									...prev,
									props: { ...prev.props, [key]: true }
								}))} />)
					: key === 'xData' ? <input type='text' className='add-column' placeholder={capitalize(key)}
						style={{ padding: '4px 10px', color: 'var(--cell--color)', caretColor: 'var(--cell--color)' }}
						value={edit.props[key] !== null ? edit.props[key] : ''}
						onChange={(e) => setEdit({
							...edit,
							props: {
								...edit.props,
								[key]: e.target.value.split(',')
							}
						})} />
						: null}

		</div>
	))}
	</Fragment>
);

export default ChartWidgetSettings;
